import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";
import { SmartImage } from "components/atoms";
import { CharacterName } from "utils/firstCharacterName";
import dayjs from "dayjs";
function ModalTeamMembers({ row }) {
  //const dispatch = useDispatch();
  //   const { id } = useParams();

  //   useEffect(() => {
  //     dispatch(GetReviewsAction({ id }));
  //   }, [id]);
  //   const { reviews } = useSelector((state) => state.reviews);
  console.log(row);
  return (
    <Card className="min-w-full">
      <CardHeader>
        <CardTitle>Team Members Detail</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3">
        <Table className="text-left text-sm text-muted-foreground">
          <TableBody>
            <TableRow>
              <TableCell className=" text-foreground ">
                <div className="size-[40px] rounded-full overflow-hidden">
                  <SmartImage
                    src={row.original.profile_url}
                    alt="User"
                    className="img-cover w-24 h-24 rounded-full"
                    fallback={
                      <div className="size-10 bg-[#d3e6ff] rounded-full flex justify-center items-center">
                        <span className="text-[#2563eb] text-[16px]">
                          {CharacterName(row.original.name)}
                        </span>
                      </div>
                    }
                  />
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Name
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">{row.original.name}</div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Email
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">{row.original.email}</div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Role
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">
                  {row.original.roles.name}
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="py-4 min-w-28 text-secondary-foreground font-normal">
                Last Modified
              </TableCell>
              <TableCell className="py-4 text-foreground ">
                <div className="flex justify-end">
                  {dayjs(Number(row.original.updated_at)).format(
                    "DD/MM/YYYY hh:mm A"
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default ModalTeamMembers;
